import React from 'react'
import '../../stylesheets/ParagraphSS.css'

function Paragraph({text}) {
    //formatting the paragraph:
    let text_formatting = {__html:`<span id="span_text">${text}</span>`};
  return (
    <div id='html_text' dangerouslySetInnerHTML={text_formatting}></div>
  )
}

export default Paragraph